import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'next-i18next';
import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/CategoryAsideFilters/CategoryAsideFilters.styles';
import CategoryGalleryStore from '@features/cms/components/categories/CategoryGalleryBlock/mobx/store/CategoryGalleryStore';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import Checkbox from '@components/Checkbox/Checkbox';
import useInflectedTranslation from '@hooks/useInflectedTranslation';
import CategoryGalleryFiltrationState from '@features/cms/components/categories/CategoryGalleryBlock/mobx/state/CategoryGalleryFiltrationState';
import { ICategoryFilterValue } from '@features/cms/components/categories/CategoryGalleryBlock/typescript';
type PropsType = {
  categoryStore: CategoryGalleryStore;
};
const CategoryAsideFilters = ({
  categoryStore
}: PropsType) => {
  const {
    t
  } = useTranslation('filters');
  const {
    getInflectedTranslation
  } = useInflectedTranslation();
  const {
    backToMainAside,
    asideAttributeOpen,
    allImagesCount,
    goAsideToFilter,
    availableFiltersState,
    selectedFiltersState,
    setSelectedFiltersState,
    closeAside,
    getImagesCountWithFilter
  } = categoryStore;
  const [newFiltersState, setNewFiltersState] = useState<CategoryGalleryFiltrationState | null>(selectedFiltersState ? new CategoryGalleryFiltrationState([...selectedFiltersState.attributes]) : null);
  const isMainAside = !asideAttributeOpen || asideAttributeOpen === '';
  const handleChangeStateValue = (attributeCode: string, value: ICategoryFilterValue, isSelected: boolean) => {
    if (!newFiltersState) return;
    if (isSelected) {
      newFiltersState.selectValue(attributeCode, value);
    } else {
      newFiltersState.deselectValue(attributeCode, value.code);
    }
    setNewFiltersState(new CategoryGalleryFiltrationState(newFiltersState.attributes));
  };
  const handleResetFilters = () => {
    if (!newFiltersState) return;
    newFiltersState.deselectAllValues();
    setNewFiltersState(new CategoryGalleryFiltrationState(newFiltersState.attributes));
  };
  const handleConfirmFilters = () => {
    if (!newFiltersState) return;
    setSelectedFiltersState(newFiltersState.attributes);
    closeAside();
  };
  return <div sx={styles.container}>
      {isMainAside ? <div sx={styles.headerContainer(false)}>
          <Heading h={4} headingType={4} bold addSx={styles.header}>
            {t('filters')}
          </Heading>
        </div> : <div sx={styles.headerContainer(true)}>
          <Button variant="iconOnly" onClick={() => backToMainAside()}>
            <Icon icon="ArrowBack" size="24px" />
          </Button>
          <Heading h={4} headingType={4} bold mobile addSx={styles.header}>
            {t('filters')}
          </Heading>
        </div>}
      <div sx={styles.asideContent}>
        {isMainAside ? <div sx={styles.attributesContainer}>
            {availableFiltersState?.attributes.map(attribute => {
          const selectedValuesCount = newFiltersState?.getValuesByAttributeCode(attribute.code).length || 0;
          return <Button variant="iconOnly" fullWidth key={`attributeFilter_${attribute.code}`} addSx={styles.singleAttribute} onClick={() => goAsideToFilter(attribute.code)}>
                  <Heading h={5} headingType={5} bold addSx={styles.attributeHeading}>
                    {attribute.name}
                    {selectedValuesCount > 0 && <p className="subtitle">({selectedValuesCount})</p>}
                  </Heading>

                  <Icon icon="Add" size="16px" />
                </Button>;
        })}
          </div> : <div sx={styles.valuesContainer}>
            {availableFiltersState?.getValuesByAttributeCode(asideAttributeOpen).map(singleValue => <div sx={styles.singleValue} key={`attribute_${asideAttributeOpen}_${singleValue.code}`}>
                <Checkbox value={newFiltersState?.getValuesByAttributeCode(asideAttributeOpen)?.some(filter => filter.code === singleValue.code) ?? false} onChange={value => {
            handleChangeStateValue(asideAttributeOpen, singleValue, value);
          }}>
                  <p className="subtitle">{singleValue.name}</p>
                </Checkbox>
              </div>)}
          </div>}

        <div sx={styles.buttonsContainer}>
          {newFiltersState && <p sx={styles.buttonsCount}>
              {getImagesCountWithFilter(newFiltersState)} {getInflectedTranslation(allImagesCount, 'arrangement')}
            </p>}
          <Button variant="outlined" variantColor="dark" size="small" fullWidth letterCase="lowercase" onClick={() => handleResetFilters()}>
            {t('resetFilters')}
          </Button>

          <Button variant="default" variantColor="dark" size="small" fullWidth letterCase="lowercase" onClick={() => handleConfirmFilters()}>
            {t('filterChoice')}
          </Button>
        </div>
      </div>
    </div>;
};
export default observer(CategoryAsideFilters);